export default class Address {

  public countryId = ''
  public countryName = ''
  public city = ''
  public addressLine = ''
}
